import React, { RefObject } from 'react';
import type { MouseEvent } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import dataBlockStyles from '../../../stylesheets/management_site/dataBlock.module.scss';

interface EditFieldButtonProps {
  inputElement: RefObject<HTMLElement>;
  editOnClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

const EditFieldButton = ({
  inputElement,
  editOnClick,
}: EditFieldButtonProps) => {
  const openDropdown = (selectEl: HTMLElement): void => {
    const isSelect2 = selectEl.classList.contains('select2-hidden-accessible');
    if (isSelect2) {
      const wrapper = selectEl.nextElementSibling;
      const clickable = wrapper?.querySelector('.select2-selection');
      clickable?.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
    } else {
      selectEl.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
    }
  };

  const editAndSelect = (e: MouseEvent<HTMLButtonElement>): void => {
    if (editOnClick) {
      editOnClick(e);
    }
    if (inputElement) {
      setTimeout((): void => {
        const element = inputElement.current;
        if (element) {
          if (element.tagName === 'SELECT') {
            openDropdown(element);
          } else {
            element.focus();
            if ('select' in element && typeof element.select === 'function') {
              element.select();
            }
          }
        }
      }, 50);
    }
  };

  return (
    <>
      {editOnClick && (
        <button
          className="mdc-button mdc-button--dense mdc-button-icon mdc-button-row pm-text-color--blue1 pm-display"
          data-mdc-auto-init="MDCRipple"
          onClick={editAndSelect}
          data-test-class="edit-data-block-button"
        >
          <EditIcon className={dataBlockStyles.editIcon} />
        </button>
      )}
    </>
  );
};

export default EditFieldButton;
